<script setup lang="ts">
import { propTypes } from '@/utils/propTypes'

const props = defineProps({
  desc: propTypes.string.def('暂无数据'),
  size: propTypes.number.def(200),
})
</script>

<template>
  <el-empty :description="desc" :image-size="props.size" />
</template>
